import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const config = {
  apiKey: "AIzaSyDmlXLKi_CIs0fnIXU0vGkCQK7sR_dWbCw",
  authDomain: "employeeclock-ba637.firebaseapp.com",
  databaseURL: "https://employeeclock-ba637.firebaseio.com",
  projectId: "employeeclock-ba637",
  storageBucket: "employeeclock-ba637.appspot.com",
  messagingSenderId: "946973661935"
};
  
firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
